/* script */

// Components
import GenericAPI from 'docs/components/GenericAPI.vue';

// Constants
import { PACKAGE_API_ROUTE } from 'docs/core/router';

// Utils
import { isEmpty, clone } from 'lodash';

/**
 * This component is an extension of GenericAPI for rendering
 * package based APIs.
 *
 * @implement {Function} getDocumentation
 * @implement {Function} getDocumentationUrl
 *
 * @category docs.components
 * @exports PackageAPI
 */
const __vue_script__ = {
    name: 'PackageAPI',

    extends: GenericAPI,

    data() {
        return {
            showPackagePicker: true,
            packages: {},
            package: {}
        };
    },

    methods: {
        /**
         * This method returns a promise containing the API documentation
         * as specified on Open API contract.
         *
         * @throws {Error} every kind of network or functional errors
         *
         * @returns {Promise<Object>} the Open API documentation JSON for events
         */
        async getDocumentation() {
            if (isEmpty(this.packages)) {
                this.packages = await this.$services.apiDoc.getPackages();
            }

            let { pkgName, version } = this.$route.params;

            if (!pkgName || !version) {
                pkgName = pkgName || Object.keys(this.packages)[0];
                const versions = this.packages[pkgName].versions;

                version = version || versions[versions.length - 1];

                this.package = { pkgName, version };
                this.packageChange();
            } else {
                this.package = clone(this.$route.params);
            }


            return this.$services.apiDoc.getPackageDocs(this.package.pkgName, this.package.version);
        },

        /**
         * This method returns a string representing the API documentation URL.
         *
         * @returns {String} the Open API documentation URL
         */
        getDocumentationUrl() {
            return this.$services.apiDoc.getPackageDocsUrl(this.package.pkgName, this.package.version);
        },

        /**
         * Package picker event handler
         * @param {Object|Null} newValue
         */
        packageChange(newValue = false) {
            const location = {
                name: PACKAGE_API_ROUTE,
                params: this.package
            };

            if (newValue) {
                this.$router.push(location, this.init);
            } else {
                this.$router.push(location);
            }
        }
    }
};

/* template */

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = undefined
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "PackageAPI.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__